export enum resources {
  skip = 'skip', // used for not tracking while patient is exists
  general = 'general',
  courses = 'courses',
  communication = 'communication',
  data = 'data',
  activityLog = 'activity_log',
}
